import queryString from 'querystring';
import axiosInstance from '../../axios-config';

const putConfirmEmailUrl = '/api/users/{userId}/confirmEmail/';
const getIsUserIdValidUrl = '/api/users/{userId}/validateuser/{encryptedUserId}/{username}';
const updatePasswordByIdUrl = '/api/users/{userId}/changePassword';
const updatePasswordByUserNameUrl = '/api/users/changePassword';
const initiatePatientKioskUserLogonUrl = 'api/kiosk/patient/{patientId}/initiateLogon';

export const login = (creds) =>
  axiosInstance.post('/token', queryString.stringify({
    grant_type: 'password',
    username: creds.username,
    password: creds.password,
  }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'portal-type': 'patientPortal',
    },
    validateStatus: function validateStatus(status) {
      return status < 400;
    },
  })
    .then((response) => response.data);

export const kioskLogin = (creds) =>
  axiosInstance.post('/token', queryString.stringify({
    grant_type: 'password',
    username: creds.username || '',
    password: creds.password || '',
  }), {
    headers: creds.type && creds.type === 'patientLinkUser' ? {
      'Content-Type': 'application/x-www-form-urlencoded',
      'portal-type': 'patientPortal',
      'equicare-logon-process': creds.type,
      'link-data': creds.data,
      'last-name': creds.lastName,
      'birth-date': `${creds.year}/${creds.month}/${creds.day}`,
    } : {
      'Content-Type': 'application/x-www-form-urlencoded',
      'portal-type': 'kioskManagement',
      'equicare-logon-process': 'patientKioskManagement',
    },
    validateStatus: function validateStatus(status) {
      return status < 400;
    },
  })
    .then((response) => response.data);

export const initiatePatientKioskUserLogon = (patientId) =>
  axiosInstance.post(initiatePatientKioskUserLogonUrl.replace('{patientId}', patientId),
    null, {
      validateStatus: function validateStatus(status) {
        return status < 400;
      },
    })
    .then((response) => response.data);


export const singleSignOnLogin = (id) =>
  axiosInstance.post('/token', queryString.stringify({
    grant_type: 'password',
    username: '',
    password: '',
  }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'portal-type': 'patientPortal',
      'equicare-logon-process': 'singleSignOn',
      'sso-id': id,
    },
    validateStatus: function validateStatus(status) {
      return status < 400;
    },
  })
    .then((response) => response.data);

export const patientKioskUserLogin = (id) =>
  axiosInstance.post('/token', queryString.stringify({
    grant_type: 'password',
    username: '',
    password: '',
  }), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'portal-type': 'patientPortal',
      'equicare-logon-process': 'patientKioskUser',
      'sso-id': id,
    },
    validateStatus: function validateStatus(status) {
      return status < 400;
    },
  })
    .then((response) => response.data);


export const getRefreshedToken = (creds) =>
  axiosInstance.post('/token', queryString.stringify({
    grant_type: 'refresh_token',
    refresh_token: creds.refresh_token,
  }), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    validateStatus: function validateStatus(status) {
      return status < 400;
    },
  })
    .then((response) => response.data);

export const updatePasswordById = (userId, oldPwd, newPwd, confirmNewPwd) =>
  axiosInstance.put(updatePasswordByIdUrl.replace('{userId}', userId),
    {
      oldPassword: oldPwd,
      newPassword: newPwd,
      confirmPassword: confirmNewPwd,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      validateStatus: (status) => status < 400,
    }
  );
export const updatePasswordByUserName = (userName, oldPwd, newPwd, confirmNewPwd) =>
  axiosInstance.put(updatePasswordByUserNameUrl,
    {
      userName,
      oldPassword: oldPwd,
      newPassword: newPwd,
      confirmPassword: confirmNewPwd,
    },
    { headers: { 'Content-Type': 'application/json' } }
  );

export const resetPassword = (username, languageCode) =>
  axiosInstance.post('/api/users/forgotPassword', '',
    {
      params: {
        userName: username,
        language: languageCode,
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'portal-type': 'patientPortal',
      },
      validateStatus: function validateStatus(status) {
        return status;
      },
    }
  );

export const putConfirmEmail = (userId) =>
  axiosInstance.put(putConfirmEmailUrl
    .replace('{userId}', userId)
  );

export const getIsUserIdValid = (userId, username, encryptedUserId) =>
  axiosInstance.get(getIsUserIdValidUrl
    .replace('{userId}', userId)
    .replace('{encryptedUserId}', encryptedUserId)
    .replace('{username}', username)
  );
